import I18N from "@/i18n";

export function translateError(code: string) {
  if (I18N.te(`error.${code}`)) {
    return I18N.t(`error.${code}`).toString();
  } else {
    return I18N.t(`error.unknown`).toString();
  }
}
